// extracted by mini-css-extract-plugin
module.exports = {"prefooterNewsletterForm":"style_prefooterNewsletterForm__f21P_ g-grid-container","content":"style_content__VIGew"};